import { IOrganizationEvents } from 'core/interfaces/IOrganization';
import { Channel } from 'pusher-js';
import { useRef } from 'react';
import { API } from 'core';

function useIncidentWatcherPusherEvents() {
  const socketi = useRef<Channel | null>(null);

  const bindPusherEvents = ({ incidentId, cb }: { incidentId: string; cb: () => void }) => {
    socketi.current = API.socket.subscribe(incidentId);

    socketi.current.bind('reload-event', (data: { message: IOrganizationEvents }) => {
      if (data.message === 'reload-incident-watchers') {
        cb();
      }
    });
  };

  const unbindPusherEvents = () => {
    if (socketi.current) {
      socketi.current.unbind('reload-event');
    }
  };
  return { bindPusherEvents, unbindPusherEvents };
}

export default useIncidentWatcherPusherEvents;
